export enum ShiftTypeEnum {
    Predictive = 0,
    Post = 1
}
